import { useEffect, type ReactNode } from 'react';

import { authRepository } from '@/features/auth/api/auth.repository';
import { useSessionStore } from '@/stores/session.store';

/**
 * Bridges Supabase auth state into the session store. The only place that
 * initializes the identity; components read it via `useSessionStore`.
 */
export function AuthProvider({ children }: { children: ReactNode }): JSX.Element {
  const setUser = useSessionStore((s) => s.setUser);

  useEffect(() => {
    let active = true;
    void authRepository.getUserId().then((id) => {
      if (active) setUser(id);
    });
    const unsubscribe = authRepository.onAuthChange((id) => setUser(id));
    return () => {
      active = false;
      unsubscribe();
    };
  }, [setUser]);

  return <>{children}</>;
}
